var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { Button, ButtonMinus, Intent } from "framework/controls/button";
import { LoadingSpinner, LoadingError } from "framework/controls/loading";
import { useEventsPlanningOfficialsItemEdit, EventsPlanningOfficialsItemEditContainer } from "./itemStore";
import { OfficialRoleSelector } from "./officialSelector";
import { cls_item_container_1, cls_item_container_2, cls_item_container_3, cls_padding_top, cls_padding_double_line, } from "./view.css";
import { cls_table_row } from "style/table.css";
import { cls_colorGrey90, cls_colorMagenta60, cls_gap_form, cls_gap_half_rem, cls_gap_rem, cls_p6r } from "style/index.css";
import { getAdjudicatorLicensesString, getOfficialLicenseName, OfficialRole } from "public_app/officials/entity";
import { NewOfficialDialog } from "./newOfficial";
import { RegisterForeignAdjudicatorDialog } from "./registerForeignAdjudicator";
import { cls_align_items_center, cls_align_items_flex_start, cls_align_items_stretch, cls_justify_content_flex_end, cls_justify_content_flex_start, cls_justify_content_space_between } from "framework/structural_components/hbox_vbox.css";
import { GetEditPermissions } from "../permissions";
import { useEventPlanning_Event, useEventPlanning_Officials, useEventPlanning_Officials_List, useEventPlanning_Officials_Counts, useEventPlanning_Officials_AllOfficialsList } from "../store";
var Item = function (props) {
    var itemState = useEventsPlanningOfficialsItemEdit()[0];
    var _a = useEventPlanning_Officials(), state = _a[0], actions = _a[1];
    var updating = itemState.updating || state.updating;
    var showEntityError = itemState.updateFailure && itemState.errors[''];
    var entityError = itemState.updateFailure && itemState.errors[''];
    var toArray = function (err) {
        return err != null ? Array.isArray(err) ? err : [err] : null;
    };
    var license = null;
    var officialForLicense = state.allOfficials.collection.find(function (o) { return o.id == props.official.idt; });
    if (officialForLicense !== undefined) {
        if (props.official.role == OfficialRole.Adjudicator) {
            license = getAdjudicatorLicensesString(officialForLicense);
        }
        else {
            license = getOfficialLicenseName(officialForLicense, props.official.role);
        }
    }
    var editPermissions = GetEditPermissions();
    var disabled = true;
    if (props.official.role === OfficialRole.Adjudicator && (editPermissions.Running || editPermissions.r05_judgesAndOfficials)) {
        disabled = false;
    }
    if (props.official.role === OfficialRole.GeneralInvigilator && editPermissions.Action) {
        disabled = false;
    }
    if (props.official.role === OfficialRole.SyllabusInvigilator && editPermissions.Action) {
        disabled = false;
    }
    if (props.official.role === OfficialRole.Scrutineer && (editPermissions.Running || editPermissions.r05_judgesAndOfficials)) {
        disabled = false;
    }
    if (props.official.role === OfficialRole.Chairperson && (editPermissions.Running || editPermissions.r05_judgesAndOfficials)) {
        disabled = false;
    }
    return React.createElement(VBox, null,
        React.createElement(HBox, { className: [cls_gap_form, cls_align_items_center] },
            React.createElement(VBox, { className: cls_item_container_1 },
                React.createElement(VBox, null,
                    React.createElement(HBox, { className: [cls_align_items_center, cls_justify_content_space_between] },
                        React.createElement("div", null, props.official.surname + " " + props.official.name + (props.official.countryCode !== "CZE" ? " [" + props.official.countryCode + "]" : "")),
                        React.createElement("div", null, license)))),
            React.createElement(HBox, { className: [cls_gap_form, cls_align_items_center, cls_justify_content_flex_end] },
                React.createElement(VBox, { className: [cls_item_container_2, cls_align_items_stretch] },
                    React.createElement(OfficialRoleSelector, { disabled: disabled })),
                React.createElement(VBox, { className: cls_item_container_3 }, !disabled ? React.createElement(ButtonMinus, { onClick: function () { return actions.officials_deleteOfficial(props.official); }, disabled: updating, intent: Intent.NotAction }) : null))),
        showEntityError && React.createElement(VBox, null, entityError.errors),
        props.official.globalErrors && React.createElement(VBox, null, toArray(props.official.globalErrors).map(function (err, i) { return React.createElement(VBox, { key: i, className: cls_colorMagenta60 }, err); })));
};
var Content = function () {
    var _a;
    var adjudicator_counts = useEventPlanning_Officials_Counts()[0];
    var _b = useEventPlanning_Officials_List(), collection = _b[0].collection, actions = _b[1];
    var event_store = useEventPlanning_Event()[0];
    var officialErrors = (_a = event_store.errors['eventCompetitions[0].officials']) === null || _a === void 0 ? void 0 : _a.errors;
    var toArray = function (err) {
        return err != null ? Array.isArray(err) ? err : [err] : null;
    };
    var double_line_printed = false;
    var DoubleLine = function (props) {
        var print = !double_line_printed && props.role != OfficialRole.Adjudicator;
        if (print) {
            double_line_printed = true;
        }
        return print ? React.createElement(VBox, { className: [cls_table_row, cls_padding_double_line] }) : null;
    };
    var editPermissions = GetEditPermissions();
    var canAddNewOfficial = editPermissions.Running;
    return React.createElement(VBox, { className: [cls_gap_form, cls_align_items_stretch] },
        React.createElement(HBox, { className: [cls_justify_content_space_between] },
            React.createElement(HBox, { className: [cls_colorGrey90, cls_p6r, cls_gap_rem, cls_justify_content_flex_start] },
                React.createElement(VBox, { className: [cls_align_items_flex_start, cls_justify_content_flex_start] },
                    React.createElement(HBox, null, "Porotci:")),
                React.createElement(VBox, { className: [cls_align_items_flex_start, cls_justify_content_flex_start] }, adjudicator_counts.stt == adjudicator_counts.lat ?
                    React.createElement(HBox, null, adjudicator_counts.stt) :
                    React.createElement(React.Fragment, null,
                        React.createElement(HBox, null, "STT: " + adjudicator_counts.stt),
                        React.createElement(HBox, null, "LAT: " + adjudicator_counts.lat)))),
            React.createElement(VBox, { className: cls_justify_content_flex_start }, canAddNewOfficial ? React.createElement(Button, { onClick: function () { return actions.officials_openNewOfficialDialog(); } }, 'Přidat odborného pracovníka') : null)),
        React.createElement(NewOfficialDialog, null),
        React.createElement(RegisterForeignAdjudicatorDialog, null),
        React.createElement(VBox, { className: [cls_align_items_stretch, cls_gap_half_rem] }, collection.filter(function (c) { return true; }).sort(function (a, b) {
            var result;
            if (a.role == OfficialRole.Adjudicator && b.role != OfficialRole.Adjudicator) {
                return -1;
            }
            if (a.role != OfficialRole.Adjudicator && b.role == OfficialRole.Adjudicator) {
                return 1;
            }
            if (a.role > b.role) {
                return 1;
            }
            if (a.role < b.role) {
                return -1;
            }
            result = a.surname.localeCompare(b.surname, 'cs');
            if (result > 0) {
                return 1;
            }
            if (result < 0) {
                return -1;
            }
            result = a.name.localeCompare(b.name, 'cs');
            if (result > 0) {
                return 1;
            }
            if (result < 0) {
                return -1;
            }
            return 0;
        }).map(function (c) { return React.createElement(EventsPlanningOfficialsItemEditContainer, { key: c.id, official: c },
            React.createElement(VBox, { className: cls_align_items_stretch },
                React.createElement(DoubleLine, { role: c.role }),
                React.createElement(VBox, { className: [cls_table_row, cls_align_items_stretch, cls_padding_top] },
                    React.createElement(Item, __assign({ key: c.id }, c, { official: c }))))); })),
        officialErrors && React.createElement(VBox, null, toArray(officialErrors).map(function (err, i) { return React.createElement(VBox, { key: i, className: cls_colorMagenta60 }, err); })));
};
var View = function () {
    var officials_list_state = useEventPlanning_Officials_List()[0];
    var all_officials_state = useEventPlanning_Officials_AllOfficialsList()[0];
    var loadingTooLong = officials_list_state.loadingTooLong || all_officials_state.loadingTooLong;
    var loading = officials_list_state.loading || all_officials_state.loading;
    var loadFailure = officials_list_state.loadFailure || all_officials_state.loadFailure;
    var showContent = !loadFailure && !loading;
    return React.createElement(React.Fragment, null,
        loadingTooLong && React.createElement(LoadingSpinner, null),
        loadFailure && React.createElement(LoadingError, null),
        showContent && React.createElement(Content, null));
};
export { View as OfficialsEdit, };
